module.exports = __webpack_public_path__ + "static/media/todo.2f226df9.png";